import { gql, useLazyQuery } from "@apollo/client";
import { GetMainCategoryQuery, GetMainCategoryQueryVariables } from "../generated/graphql";

const GET_MAIN_CATEGORY_QUERY = gql`
  query getMainCategory($input: GetMainCategoryInput!) {
    getMainCategory(input: $input) {
      ok
      err
      mainCategory {
        id
        name
        upload {
          url
          uuid
        }
      }
    }
  }
`;

export const useGetMainCategory = (onCompleted?: (data: GetMainCategoryQuery) => void) => {
  return useLazyQuery<GetMainCategoryQuery, GetMainCategoryQueryVariables>(GET_MAIN_CATEGORY_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
